import { createApp } from 'vue'

window.rcb = window.rcb || {}

if (document.getElementById('school-of-brass-schedule-listing')) {
  const app = createApp({
    data() {
      return {
        scheduleDates: window.rcb.scheduleDates || [],
      }
    },
    computed: {
      /**
       * Group schedule dates by year/month.
       */
      scheduleDateMonths() {
        let dates = this.scheduleDates.reduce((accumulator, currentValue) => {
          const scheduleDate = new Date(currentValue.timestamp * 1000)
          const monthString = scheduleDate.getFullYear() + '-' + (((parseInt(scheduleDate.getMonth()) + 1).toString()).padStart(2, '0'))

          accumulator[ monthString ] = accumulator[ monthString ] || {}

          accumulator[ monthString ].title = new Intl.DateTimeFormat('en-US', {month: 'long', year: 'numeric'}).format(scheduleDate)

          accumulator[ monthString ].scheduleDates = accumulator[ monthString ].scheduleDates || []
          accumulator[ monthString ].scheduleDates.push(currentValue)

          return accumulator
        }, {})

        // Sort groups in ascending order.
        let groupedDates = Object.keys(dates).sort().reduce((result, key) => {
          result[key] = dates[key]
          return result
        }, {})

        return groupedDates
      },
      totalDates() {
        return this.scheduleDates.length
      }
    },
  })

  app.mount('#school-of-brass-schedule-listing')
}
